(function (angular) {
    'use strict';

    angular.module('app')
        .controller('forumIndexController', forumIndex);

    forumIndex.$inject = [
        'ForumCategoriesApi',
        '$scope'

    ];

    function forumIndex(
        ForumCategoriesApi,
        $scope

    ) {
        var vm = this;
        vm.limit = 9;

        vm.getCategories = getCategories;
        vm.orderCategories = orderCategories;

        /**
         * Get information about a specific category, whether that's the data
         * about a category, or the replies which it is getting.
         *
         * @param  {Number} id
         * @return {void}
         */
        function getCategories() {
            ForumCategoriesApi.query({}, function handle(categories) {
                vm.categories = categories;
                vm.isLoading = false;
            }, function error() {
                vm.isLoading = false;
            });
        }
        $scope.loadMore = function() {
            var increamented = vm.limit + 3;
            vm.limit = increamented > vm.categories.length ? vm.categories.length : increamented;
          };
        /**
         * Change the order of the categories and then call the API, to request
         * the new order.
         *
         * @return {void}
         */
        function orderCategories() {
            angular.merge(vm.filters, vm.selectedOrderFilter);
            delete vm.filters.label;
            vm.getCategories();
        }

        vm.getCategories();
    }
    

}(angular));